import React, { useState } from 'react';
import { CheckCircle2, ChevronRight, ChevronDown } from 'lucide-react';

/* ─── Agreement Section (collapsible)
   Moved verbatim from src/pages/BookingConfirmationPage.jsx.
   Same JSX, same styling, same data bindings. ─── */

export default function Agreement({ booking, snapshot, getPayUnitLabel, getPaymentTimingLabel }) {
  const [open, setOpen] = useState(false);

  return (
    <div
      data-testid="agreement-card"
      className="mb-6 overflow-hidden"
      style={{ background: '#171411', borderRadius: 16, border: '1px solid rgba(212, 169, 90, 0.12)' }}
    >
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-5 py-4"
        type="button"
      >
        <div className="flex flex-col items-start">
          <h2 style={{ fontFamily: 'var(--s8-font-mono)', fontWeight: 500, fontSize: 18, letterSpacing: '0.04em', color: '#F0EBE0' }}>
            AGREEMENT
          </h2>
          {!open && (
            <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 13, color: '#a39889', marginTop: 2 }}>
              <CheckCircle2 size={12} color="#5a9a6d" className="inline mr-1" style={{ verticalAlign: '-1px' }} />
              Signed · €{snapshot.fee || 750} {getPayUnitLabel(snapshot.payUnit || 'flat').toLowerCase()} · {getPaymentTimingLabel(snapshot.paymentTiming || 'same_night')}
            </span>
          )}
        </div>
        <ChevronDown
          size={18}
          color="#888"
          className="shrink-0"
          style={{ transition: 'transform 0.2s', transform: open ? 'rotate(180deg)' : 'rotate(0deg)' }}
        />
      </button>
      {open && (
        <div className="px-5 py-4 space-y-3" style={{ background: '#1e1b16', borderTop: '1px solid #2a2620' }}>
          <div className="flex justify-end mb-1">
            <button
              data-testid="agreement-view-pdf"
              className="flex items-center gap-1 px-3 py-1.5 rounded-lg text-xs transition-all hover:brightness-110"
              style={{ fontFamily: "'DM Mono', monospace", fontSize: 11, letterSpacing: 0.3, color: '#E6A23C', background: 'rgba(230,162,60,0.07)', border: '1px solid rgba(230,162,60,0.19)' }}
            >
              View PDF
              <ChevronRight size={12} />
            </button>
          </div>
          <div className="flex items-center justify-between">
            <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: '#888' }}>Venue signed</span>
            <span className="flex items-center gap-2" style={{ fontFamily: "'DM Mono', monospace", fontSize: 12 }}>
              <CheckCircle2 size={14} color="#5a9a6d" />
              <span style={{ color: '#F0EBE0' }}>
                {booking.venueProfile?.venueName || snapshot.venueName || 'Cinetol'} · 10 Apr
              </span>
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: '#888' }}>Artist signed</span>
            <span className="flex items-center gap-2" style={{ fontFamily: "'DM Mono', monospace", fontSize: 12 }}>
              <CheckCircle2 size={14} color="#5a9a6d" />
              <span style={{ color: '#F0EBE0' }}>
                {booking.talentProfile?.displayName || snapshot.talentName || 'Sophie van den Berg'} · 12 Apr
              </span>
            </span>
          </div>
          <div style={{ borderTop: '1px solid #2a2620', paddingTop: 12 }} className="flex items-center justify-between">
            <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: '#888' }}>Fee</span>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: '#F0EBE0' }}>
              €{snapshot.fee || 400} {getPayUnitLabel(snapshot.payUnit || 'flat').toLowerCase()}
            </span>
          </div>
          <div className="flex items-center justify-between">
            <span style={{ fontFamily: "'Barlow', sans-serif", fontSize: 13, color: '#888' }}>Payment</span>
            <span style={{ fontFamily: "'DM Mono', monospace", fontSize: 12, color: '#F0EBE0' }}>
              {getPaymentTimingLabel(snapshot.paymentTiming || 'same_night')} · IBAN ·· 4421
            </span>
          </div>
        </div>
      )}
    </div>
  );
}
